<template>
    <div>
        <h1>Mina butiker</h1>

        <ul>
            <li v-for="store in stores">
                <router-link :to="/store/ + store.id">{{ store.name }}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'StoreButtonList',
    props: ['stores']
}
</script>
